/* eslint-disable react-hooks/exhaustive-deps */
import CustomButton from "components/CustomButton/CustomButton";
import { useEffect, useState } from "react";

const Footer = ({
    form, closeDialog, updateAction
}) => {
    const [disabledUpdateButton, setDisabledUpdateButton] = useState(false);
    useEffect(() => {
        setDisabledUpdateButton(!form.areThereChanges() || !form.isCompleted());
    }, [form.value]);
    return (
        <>
        <CustomButton
            width="120px"
            variant="secondary"
            text="No, cancelar"
            onClick={closeDialog}/>
        <CustomButton 
            text="Sí, editar"
            width="120px"
            onClick={() => updateAction(form.value)}
            disabled={disabledUpdateButton}/>
        </>
    );
}

export default Footer;